export class PreferencesCenterSettings {
  constructor(overrides) {
    const defaults = {
      spacing: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 20
      },
      panelSpacing: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 20
      },
      headerFont: {
        fontSize: 16,
        fontWeight: '600',
        color: '#000000',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      descriptionFont: {
        fontSize: 13,
        fontWeight: '500',
        color: '#000000',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      channelFont: {
        fontSize: 13,
        fontWeight: '500',
        color: '#000000',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      toggleOnColor: '#47d747',
      toggleOffColor: 'gray',
      checkBoxColor: '',
      unsubscribeText: 'Unsubscribe from all preferences',
      languages: {},
      categoryName: '',
      categoryDescription: '',
      categories: {
        ids: [],
        hide: false
      },
      toggleType: 'slider',
      togglePosition: 'right'
    };
    Object.assign(this, defaults, overrides);
  }
}
export const preferencesCenterTypes = {
  category: {
    categories: {
      title: '',
      type: 'CategorySelector'
    }
  },
  content: {
    categoryName: {
      title: 'Category Name',
      type: 'InputLanguage'
    },
    categoryDescription: {
      title: 'Category Description',
      type: 'InputLanguage'
    }
  },
  fonts: {
    headerFont: {
      title: 'Header Font',
      type: 'Font'
    },
    descriptionFont: {
      title: 'Description Font',
      type: 'Font'
    },
    channelFont: {
      title: 'Channel Font',
      type: 'Font'
    }
  },
  'selection controls': {
    toggleType: {
      title: 'Type',
      type: 'RadioSelector'
    },
    togglePosition: {
      title: 'Control Position',
      type: 'RadioSelector'
    }
  },
  'control color': {
    toggleOnColor: {
      title: 'ON color',
      type: 'ColorPicker'
    },
    toggleOffColor: {
      title: 'OFF color',
      type: 'ColorPicker'
    }
  },
  spacing: {
    spacing: {
      title: 'Spacing',
      type: 'Padding'
    },
    panelSpacing: {
      title: 'Panel Spacing',
      type: 'Padding'
    }
  },
  checkboxes: {
    checkBoxColor: {
      title: 'Checkbox Color',
      type: 'ColorPicker'
    },
    checkColor: {
      title: 'Check Color',
      type: 'ColorPicker'
    }
  }
};